import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { authSelector } from "../store/slices/auth";

export default function SecuredLogin(props: any) {
  const { isAuth } = useSelector(authSelector);
  const location = useLocation();

  // Extract query params
  const searchParams = new URLSearchParams(location.search);
  const topicId = searchParams.get("topicId");
  const formId = searchParams.get("formId");

  // Allow unauthenticated users to access `/?topicId=...&formId=...`
  const isPublicSurveyAccess =
    location.pathname === "/" && topicId && formId;

  if (isAuth || isPublicSurveyAccess) {
    return props.children;
  }

  return <Navigate to="/login" replace />;
}
